import api from "./Client";
import { SecureStorage } from "../storage/SecureStorage";

export interface User {
  id: number;
  fullName: string;
  email: string;
  phone?: string;
  sex?: string;
  dateOfBirth?: string;
  postcode?: number | null;
  postAddress?: string;
  dni?: string | null;
  profilePictureName?: string | null;
  profilePictureUrl?: string | null;
}

/** Carga el perfil completo desde backend y lo guarda en SecureStorage */
export async function fetchUserProfile(userId: number): Promise<User> {
  const res = await api.get<User>("/api/mobile/user", {
    params: { user_id: userId },
  });
  const user = res.data;
  await SecureStorage.saveUser(user);
  return user;
}
